<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin khóa học]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm khóa học</li>
                        <li @click="scrollToElement('vn-3')">Thông tin khóa học</li>
                        <li @click="scrollToElement('vn-4')">Danh sách học viên</li>
                        <li @click="scrollToElement('vn-5')">Danh sách bài tập</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.Cách vào màn hình [Thông tin khóa học]</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Avatar] hoặc [Tên người dùng] để mở menu quản lý dành cho giáo viên.</p>
                    <p>② Khi nhấn vào mục [Thông tin khóa học ] thì sẽ chuyển đến màn hình [Thông tin khóa học] gồm tất cả các khóa học mà giáo viên phụ trách.</p>
                </div>
                <div id="vn-2">
                    <h1>2.Tìm kiếm khóa học</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-2.png" alt="" /></div>
                <div>
                    <p>Nhập tên khóa học muốn tìm kiếm</p>
                </div>
                <div id="vn-3">
                    <h1>3.Thông tin khóa học</h1>
                </div>
                <div>
                    <p>
                        <b><i>3.1 Nội dung chi tiết</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-3.png" alt="" /></div>
                <div>
                    <p>Nhấn vào nút [Nội dung chi tiết] để đến màn hình [Chi tiết khóa học]</p>
                </div>
                <div>
                    <p>
                        <b><i>3.2 Xuất thành tích học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4.Danh sách học viên</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1 Tìm kiếm theo từ khóa</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-5.png" alt="" /></div>
                <div>
                    <p>Nhập tên học viên muốn tìm kiếm</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2 Sắp xếp theo trạng thái của học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-6.png" alt="" /></div>
                <div>
                    <p>Nhấn vào các nút để hiển thị hoặc không hiển thị các học viên ứng với trạng thái</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3 Chi tiết khóa học đối của học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-7.png" alt="" /></div>
                <div>
                    <p>Nhấn vào học viên cần xem nội dung chi tiết</p>
                </div>
                <div>
                    <p>
                        <b><i>4.4 Danh sách câu trả lời sai của bài tập nhỏ</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-8.png" alt="" /></div>
                <div>
                    <p>Nhấn vào tỉ lệ điểm để xem danh sách câu sai bài tập nhỏ của học viên</p>
                </div>
                <div id="vn-5">
                    <h1>5. Danh sách bài tập</h1>
                </div>
                <div>
                    <p>
                        <b><i>5.1 Tìm kiếm câu hỏi</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-9.png" alt="" /></div>
                <div>
                    <p>① Nhập ID câu hỏi muốn tìm kiếm</p>
                    <p>② Nhập tiêu đề câu hỏi cần tìm kiếm</p>
                    <p>③ Chọn hình thức câu hỏi cần tìm kiếm</p>
                    <p>④ Chọn loại câu hỏi cần tìm kiếm</p>
                    <p>⑤ Chọn giáo viên tạo câu hỏi cần tìm kiếm</p>
                    <p>⑥ Chọn ngày tạo câu hỏi cần tìm kiếm</p>
                    <p>⑦ Chọn loại nội dung có trong câu hỏi cần tìm kiếm</p>
                    <p>⑧ Các điều kiện tìm kiếm và nội dung trở về trạng thái ban đầu</p>
                </div>
                <div>
                    <p>
                        <b><i>5.2 Chi tiết câu hỏi</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-10.png" alt="" /></div>
                <div>
                    <p>Nhấn vào câu hỏi cần xem nội dung chi tiết</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/manageCourse_manual.vue